import {
    EventPanelFormType,
    ApiResultServiceRotationModal,
    ServiceRotationOption,
    EventPanelConfiguration,
    ConsolidatedLocationView,
} from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { getInitialValuesForTowVehicle } from '../event-panel/event-panel-form/helpers/vehicle-helpers';
import { getDefaultVehicle } from '../event-panel/event-panel-form/involved-person-vehicle-fields/vehicles/event-panel-vehicle-helpers';

type EventPanelTowVehiceFormType = EventPanelFormType['towVehicles'][0];

function getNewTowVehicle({
    eventForm,
    eventPanelConfiguration,
    vehicleIndexInOptionsList,
    serviceRotationModalResponse,
    serviceProvider,
}: {
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelConfiguration: EventPanelConfiguration;
    vehicleIndexInOptionsList: number;
    serviceRotationModalResponse: ApiResultServiceRotationModal;
    serviceProvider: ServiceRotationOption;
}): EventPanelTowVehiceFormType {
    const location = eventForm.getValues().location;

    return {
        ...getDefaultVehicle({
            eventPanelConfiguration,
            towedFromLocation: location as ConsolidatedLocationView,
        }),
        ...getInitialValuesForTowVehicle('vehicles', vehicleIndexInOptionsList, eventForm),
        towCompanyOption: {
            value: serviceProvider.attributeId,
            label: serviceProvider.label,
            isOther: false,
        },
        towedToLocation: serviceProvider.consolidatedLocationView ?? null,
        towTypeOption: { label: 'Department', value: 'Department' },
        rotationServiceListPositionId:
            serviceRotationModalResponse.data?.rotationServiceListPositionId ?? null,
    };
}

export function addMultiTowVehiclesToEventForm({
    eventForm,
    selectedMultiVehiclesIndexes,
    selectedMergedMultiVehiclesIndexes,
    serviceRotationModalResponse,
    serviceProvider,
    eventPanelConfiguration,
}: {
    eventForm: UseFormReturn<EventPanelFormType>;
    selectedMultiVehiclesIndexes: number[];
    selectedMergedMultiVehiclesIndexes: number[];
    serviceRotationModalResponse: ApiResultServiceRotationModal;
    serviceProvider: ServiceRotationOption;
    eventPanelConfiguration: EventPanelConfiguration;
}) {
    const newTowVehicles: EventPanelFormType['towVehicles'][0][] = [];
    const currentTowVehicles = eventForm.getValues().towVehicles;

    for (const selectedVehicleIndex of selectedMultiVehiclesIndexes) {
        newTowVehicles.push(
            getNewTowVehicle({
                eventForm,
                eventPanelConfiguration,
                vehicleIndexInOptionsList: selectedVehicleIndex,
                serviceRotationModalResponse,
                serviceProvider,
            })
        );
    }

    for (const selectedMergedVehicleIndex of selectedMergedMultiVehiclesIndexes) {
        newTowVehicles.push(
            getNewTowVehicle({
                eventForm,
                eventPanelConfiguration,
                vehicleIndexInOptionsList: selectedMergedVehicleIndex,
                serviceRotationModalResponse,
                serviceProvider,
            })
        );
    }

    eventForm.setValue('towVehicles', [...currentTowVehicles, ...newTowVehicles], {
        shouldDirty: true,
        shouldValidate: true,
    });
}
